module.exports = __webpack_public_path__ + "static/banner-2-f91f08eacd07eb936182c5e7da5d24fb.jpg";